var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.31,11.07c.62,0,1.19,.39,1.42,.96l.93-.37c-.21-.53-.6-.96-1.07-1.24,.2-.27,.32-.6,.32-.95,0-.88-.72-1.6-1.6-1.6s-1.6,.72-1.6,1.6c0,.36,.12,.69,.32,.95-.48,.28-.86,.71-1.07,1.24l.93,.37c.23-.58,.8-.96,1.42-.96Zm-.6-1.6c0-.33,.27-.6,.6-.6s.6,.27,.6,.6-.27,.6-.6,.6-.6-.27-.6-.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.42,
    y: 9.02,
    width: 4.23,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.42,
    y: 10.63,
    width: 4.23,
    height: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.82,14.26H15.27c.76,0,1.39-.65,1.39-1.45V7.41c0-.8-.62-1.45-1.39-1.45H4.82c-.76,0-1.38,.65-1.38,1.45v5.4c0,.8,.62,1.45,1.38,1.45Zm-.38-6.85c0-.25,.17-.45,.38-.45H15.27c.21,0,.39,.2,.39,.45v5.4c0,.25-.17,.45-.39,.45H4.82c-.21,0-.38-.2-.38-.45V7.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.08,4.81c0-.49-.39-.88-.88-.88H4.74c-.49,0-.88,.39-.88,.88v.52h12.23v-.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.08,2.64c0-.49-.39-.88-.88-.88H4.74c-.49,0-.88,.39-.88,.88v.52h12.23v-.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.7,10.63h-1.19v4.76c0,.12-.1,.21-.22,.21H2.65c-.12,0-.22-.1-.22-.21v-4.76H1.24c-.7,0-1.27,.57-1.27,1.27v6.71c0,.77,.62,1.39,1.39,1.39H18.58c.77,0,1.39-.62,1.39-1.39v-6.71c0-.7-.57-1.27-1.27-1.27Zm.27,7.98c0,.22-.17,.39-.39,.39H1.36c-.22,0-.39-.18-.39-.39v-6.71c0-.15,.12-.27,.27-.27h.2v3.76c0,.67,.55,1.21,1.22,1.21h14.64c.67,0,1.22-.54,1.22-1.21v-3.76h.19c.15,0,.27,.12,.27,.27v6.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.3a0c375ea3bb269cfa8eb25863a278b6.svg";
export { ForwardRef as ReactComponent };